import { render, staticRenderFns } from "./create-admins.component.html?vue&type=template&id=48f80c48&scoped=true&external"
import script from "./create-admins.component.ts?vue&type=script&lang=ts&external"
export * from "./create-admins.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-admins.component.scss?vue&type=style&index=0&id=48f80c48&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f80c48",
  null
  
)

export default component.exports